import { defineStore } from 'pinia';
import { ref, type Ref, computed } from 'vue';
import { type IUserInfo } from '@/types/profile/IUserInfo';
import { useApi } from '@beautybox/core/plugins';
import { IUserRole } from '@/types/profile/IUserRole';

const useProfileStore = defineStore('profile', () => {
    const { provider } = useApi();
    const userInfo = ref(null) as Ref<IUserInfo | null>;
    const tariff = computed(() => {
        if (!userInfo.value) {
            return null;
        }
        return userInfo.value.tariff;
    });
    const modules = computed(() => {
        if (!userInfo.value) {
            return [];
        }

        return userInfo.value.modules;
    });
    const integrations = computed(() => {
        if (!userInfo.value) {
            return [];
        }

        return userInfo.value.integrations;
    });

    function setUserInfo(payload: IUserInfo) {
        userInfo.value = { ...payload };
    }

    async function getUserInfo() {
        const { errors = {}, ...response } = await provider.get<IUserInfo>('/v4/user-info');

        if (!Object.keys(errors).length) {
            setUserInfo(response);
        }
    }

    function checkPermission(permission: string | string[]) {
        if (!userInfo.value) {
            return false;
        }
        const temp = userInfo.value;

        const test = (item: string) => temp.permission.includes(item);

        if (Object.keys(temp).length && 'permission' in temp) {
            if (typeof permission === 'string') {
                return test(permission);
            } else if (Array.isArray(permission)) {
                return !!permission.find((item) => {
                    return test(item);
                });
            }
        }
        return false;
    }

    /**
     * @deprecated TODO убрать проверку на роль, права будут на весь раздел
     */
    const isStudioMaster = computed(() => {
        return userInfo.value?.role === IUserRole.STUDIO_MASTER;
    });

    return {
        userInfo,
        isStudioMaster,
        tariff,
        integrations,
        modules,
        getUserInfo,
        setUserInfo,
        checkPermission,
    };
});

export { useProfileStore };
export default useProfileStore;
